import moment from "moment";

const filters = {
  //日期过滤器
  dateFormat: function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm';
    return moment(value).format(formatString);
  },
  durationTrans: function (value) {
    var b = ""
    var h = parseInt(value / 3600),
      m = parseInt(value % 3600 / 60),
      s = parseInt(value % 3600 % 60);
    if (h > 0) {
      h = h < 10 ? '0' + h : h
      b += h + ":"
    }
    m = m < 10 ? '0' + m : m
    s = s < 10 ? '0' + s : s
    b += m + ":" + s
    return b;
  },
  //取两位小数
  calcMoney: function (m) {
    m = m>=100 ? 100 : m;
    return Math.round(m * 100) / 100;
  },
  getDian: function (m) {
    if (m) {
      let ms = m.toString().split('.');
      let ms1 = '0';
      if (ms[1]) {
        ms1 = ms[1] ? ms[1] : '0';
      }
      return ms[0] + '.' + ms1;
    } else {
      return '0.0'
    }
  },
  getMoney: function (m) {
    if (m) {
      let ms = m.toString().split('.');
      let ms1 = '00';
      if (ms[1]) {
        ms1 = ms[1].length === 1 ? ms[1] + '0' : ms[1];
      }
      return ms[0] + '.' + ms1;
    } else {
      return '0.00'
    }
  },
  getMoney1: function (m) {
    if (m) {
      let ms = m.toString().split('.');
      return ms[0] + '.';
    } else {
      return '0.';
    }
  },
  getMoney2: function (m) {
    if (m) {
      let ms = m.toString().split('.');
      let ms1 = '00';
      if (ms[1]) {
        ms1 = ms[1].length === 1 ? ms[1] + '0' : ms[1];
      }
      return ms1;
    } else {
      return '00';
    }
  },
  //数字转金额大写
  LowertoUpper: function (n) {
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
      return "数据非法";
    var unit = "千百拾亿千百拾万千百拾元角分", str = "";
    n += "00";
    var p = n.indexOf('.');
    if (p >= 0)
      n = n.substring(0, p) + n.substr(p + 1, 2);
    unit = unit.substr(unit.length - n.length);
    for (var i = 0; i < n.length; i++)
      str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    return str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
  },
  //数字1转数字一
  upper: function (n) {
    // 提供中文数字
    var cnum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

    var s = '';
    n = '' + n; // 数字转为字符串
    for (var i = 0; i < n.length; i++) {
      s += cnum[parseInt(n.charAt(i))];
    }
    if (s.length == 2) { // 两位数的时候
      // 如果个位数是0的时候，改成十
      if (s.charAt(1) == cnum[0]) {
        s = s.charAt(0) + cnum[10];
        // 如果是一十改成十
        if (s == cnum[1] + cnum[10]) {
          s = cnum[10]
        }
      } else if (s.charAt(0) == cnum[1]) {
        // 如果十位数是一的话改成十
        s = cnum[10] + s.charAt(1);
      }
    }
    return s;
  },
  //距离结束时间还有多久
  dateFromEnd: function (value) {
    let time = new Date(value);
    console.log(time)
    let visitTime = '';
    let leftTime = parseInt((time.getTime() - new Date().getTime()) / 1000);
    let func = function checTime(i) {
      return i < 10 ? "0" + i : i + "";
    };

    let d = parseInt(leftTime / (24 * 60 * 60));
    let h = parseInt(leftTime / (60 * 60) % 24);
    let m = parseInt(leftTime / 60 % 60);
    let s = parseInt(leftTime % 60);

    let days = func(d);
    let hours = func(h);
    let minutes = func(m);
    let seconds = func(s);

    if (leftTime > 0) {
      if (days > 0) {
        setTimeout(() => {
          filters.dateFromEnd(value)
        }, 300000);
        visitTime = days + '天' + hours + '小时';
      } else if (hours > 0) {
        setTimeout(() => {
          filters.dateFromEnd(value)
        }, 5000);
        visitTime = hours + '小时' + minutes + '分钟';
      } else if (minutes > 0) {
        setTimeout(() => {
          console.log('fen秒')
          filters.dateFromEnd(value);
        }, 1000);
        visitTime = minutes + '分钟' + seconds + '秒';
      } else if (seconds > 0) {
        console.log('秒')
        setTimeout(() => {
          filters.dateFromEnd(value);
        }, 1000);
        visitTime = seconds + '秒';
      }
      return '剩余' + visitTime;
    } else {
      return filters.dateFormat(value);
    }

  },
  //数字过滤器
  numberFormat: function (value) {
    return value < 10 ? "0" + value : value + "";
  },
  getVideoTimeStr(value) {
    let time = '';
    let leftTime = value;
    if (leftTime === 0) {
      return time = '0秒';
    }
    let func = function checTime(i) {
      return i < 10 ? "0" + i : i + "";
    };
    let hours = parseInt(leftTime / (60 * 60));
    let minutes = parseInt((leftTime / 60) - hours * 60);
    let seconds = parseInt(leftTime % 60);

    if (hours > 0) {
      time += hours + '小时';
    }
    if (minutes > 0) {
      time += minutes + '分钟';
    }
    if (seconds > 0) {
      time += seconds + '秒';
    }
    return time;
  },
  getTimeLeftStrOrder: function (value) {
    let visitTime = '';
    let leftTime = value;
    let func = function checTime(i) {
      return i < 10 ? "0" + i : i + "";
    };

    let d = parseInt(leftTime / (1000 * 24 * 60 * 60));
    let h = parseInt(leftTime / (1000 * 60 * 60) % 24);
    let m = parseInt(leftTime / (1000 * 60) % 60);
    let s = parseInt(leftTime / 1000 % 60);

    let days = func(d);
    let hours = func(h);
    let minutes = func(m);
    let seconds = func(s);

    if (days > 0) {
      visitTime = days + '天' + hours + '小时';
    } else if (hours > 0) {
      visitTime = hours + '小时' + minutes + '分';
    } else if (minutes > 0) {
      visitTime = minutes + '分' + seconds + '秒';
    } else if (seconds > 0) {
      visitTime = seconds + '秒';
    }
    return visitTime;
  },
  getAvator: function (value) {
    let uploadresUrl = '//res.aqjsjx.com.cn/';
    let img = '/static/img/pro/userDefault.png';
    let avatarUrl = value;
    if (avatarUrl) {
      if (avatarUrl.indexOf('http') < 0) {
        img = uploadresUrl + avatarUrl;
      } else {
        img = avatarUrl;
      }
    }
    return img;
  },
  dateTransForm: function (value, time){

    let visitTime = '';
    const distinctTime = moment().diff(moment(value), 'milliseconds', true);

    if (distinctTime <= (1 * 60 * 1000)) {
      // console.log('一分钟以内，以秒数计算');
      const _s = Math.floor((distinctTime / 1000) % 60);
      if (_s === 0) {
        visitTime = '刚刚';
      } else {
        visitTime = _s + '秒前';
      }

    } else if (distinctTime <= (1 * 3600 * 1000)) {
      // console.log('一小时以内,以分钟计算');
      const _m = Math.floor((distinctTime / (60 * 1000)) % 60);
      visitTime = _m + '分钟前';
    } else if (distinctTime <= (24 * 3600 * 1000)) {
      // console.log('一天以内，以小时计算');
      const _h = Math.floor((distinctTime / (60 * 60 * 1000)) % 24);
      visitTime = _h + '小时前';
    } else if (distinctTime <= (30 * 24 * 3600 * 1000)) {
      const _d = Math.floor((distinctTime / (24 * 60 * 60 * 1000)) % 30);
      visitTime = _d + '天前';
    } else {
      if (time){
        // 30天以外 显示日期
        visitTime = moment(value).format('YYYY-MM-DD HH:mm');
      }else{
        // 30天以外 显示日期
        visitTime = moment(value).format('YYYY-MM-DD');
      }

    }
    return visitTime;
  }
}

export default filters;
